import { render } from "./CryptoPerformancePage.vue?vue&type=template&id=89432baa&ts=true"
import script from "./CryptoPerformancePage.vue?vue&type=script&lang=ts"
export * from "./CryptoPerformancePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__